// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    chain,
    LoadRealTimePricingAndInventory,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import loadProductsPricingAndInventory from "@insite/client-framework/Store/Pages/ProductList/Handlers/LoadProductsPricingAndInventory";
import { shouldProductLoadRealTime } from "@store/Framework/Common/Utilities/productUtilities";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, LoadRealTimePricingAndInventory, props => {
    /* Store Custom Code - Start */
    const products = props.result.products?.filter(shouldProductLoadRealTime);
    const productInfosByProductId =
        (products &&
            products.reduce<SafeDictionary<ProductInfo>>((acc, p) => {
                const info = props.result.productInfosByProductId[p.id];
                if (info !== undefined) acc[p.id] = info;
                return acc;
            }, {})) ||
        {};
    /* Store Custom Code - End */

    props.dispatch(
        loadProductsPricingAndInventory({
            products: products, // Store Custom Code
            productInfosByProductId: productInfosByProductId, // Store Custom Code
        }),
    );
});
